import React, { forwardRef } from 'react'
import { useText } from '../context/TextContext'
import { AdvancedButton } from './AdvancedButton';
import { DealFilters } from '../hooks/useDeals';
import { FormCheck } from 'react-bootstrap';
import { useOrganization } from '../context/OrganizationContext';
import { DEFAULT_TAGS } from '../models/shared/TagDefinition';

interface Props {
    filters: DealFilters,
    onUpdateFilters: (filters: DealFilters) => void
}

const DealFiltersPicker = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { filters, onUpdateFilters } = props;
    const text = useText();
    const { organization } = useOrganization();

    const toggleFilter = (type: 'steps' | 'tags', value: string) => {
        const currentValue = filters[type] || [];
        if (currentValue.includes(value)) {
            onUpdateFilters({ ...filters, [type]: currentValue.filter(v => v !== value) });
        } else {
            onUpdateFilters({ ...filters, [type]: [...currentValue, value] });
        }
    }

    return (
        <div ref={ref} className='map-menu d-flex flex-column gap-3'>
            <div className='d-flex justify-content-between'>
                <h5>{text.filters}</h5>
                <AdvancedButton className='p-0' variant='clear' onClick={() => onUpdateFilters({})}>{text.clear}</AdvancedButton>
            </div>

            <div>
                <h6>{text.step}</h6>
                <div className='d-flex flex-column gap-2'>
                    {organization.dealSteps.map(step =>
                        <FormCheck type='checkbox' key={step.id}
                            label={step.name}
                            checked={!!filters.steps?.includes(step.id)}
                            onChange={(e) => toggleFilter('steps', step.id)}
                        />
                    )}
                </div>
            </div>

            <div>
                <h6>{text.tags}</h6>
                <div className='d-flex flex-column gap-2'>
                    {(organization.tags || DEFAULT_TAGS).map(tag =>
                        <div className='d-flex gap-2' key={tag.id}>
                            <FormCheck type='checkbox'
                                checked={!!filters.tags?.includes(tag.id)}
                                onChange={(e) => toggleFilter('tags', tag.id)}
                            />
                            <div style={{ background: tag.color, width: 30 }} className='rounded' />
                            <div>{tag.text}</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
});

export default DealFiltersPicker;
